/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslation } from 'next-i18next'
import { LANGUAGES_MAP } from 'src/constants/CurrencyAndLanguageConstants'
import { Currency, Language } from 'src/types/graphql'
import BaseButton from '../Buttons/BaseButton'
import RadioButton from './RadioButton'

export type SelectorsProps = {
  selectedCurrency: Currency
  selectedLocale: Language
  handleCurrencyChange: (value: Currency, autoSet: boolean) => void
  handleLanguageChange: (locale: Language, autoSet: boolean) => void
  handleSetChanges: () => void
  autoSet?: boolean
}

export function Selectors({
  selectedCurrency,
  selectedLocale,
  handleCurrencyChange,
  handleLanguageChange,
  handleSetChanges,
  autoSet = false
}: SelectorsProps) {
  const { t } = useTranslation('nav')
  return (
    <div className="grid w-full grid-cols-2 gap-x-[22px] gap-y-[26px] pb-6 md:px-[27px] md:py-6">
      <div className="col-span-1 flex flex-col gap-4">
        <p>{t('NAV_LANGUAGE_DROPDOWN.CURRENCY')}</p>
        <div className="flex flex-col justify-stretch gap-[6px]">
          {Object.values(Currency)
            .reverse()
            .map((currency) => (
              <RadioButton
                key={currency}
                value={currency}
                checked={selectedCurrency === currency}
                onChange={() => handleCurrencyChange(currency, autoSet)}
              />
            ))}
        </div>
      </div>
      <div className="col-span-1 flex flex-col gap-4">
        <p>{t('NAV_LANGUAGE_DROPDOWN.LANGUAGE')}</p>
        <div className="flex flex-col justify-stretch gap-[6px]">
          {Object.values(Language).map((locale) => {
            const { value } = LANGUAGES_MAP[locale]
            return (
              <RadioButton
                key={t(value as any)}
                value={t(value as any)}
                checked={selectedLocale === locale}
                onChange={() => handleLanguageChange(locale, autoSet)}
              />
            )
          })}
        </div>
      </div>
      <div className="col-span-2 hidden items-center justify-center md:flex">
        <BaseButton
          fontSize={14}
          size="medium"
          width={180}
          color="primary"
          variant="contained"
          rounded
          blueBorder
          onClick={() => handleSetChanges()}
        >
          {t('NAV_LANGUAGE_DROPDOWN.APPLY')}
        </BaseButton>
      </div>
    </div>
  )
}
